import ExpiringTxView from 'src/sections/overview/expiring-tx/view/expiring-tx-view';

export default function ExpiringTx() {
  return <ExpiringTxView />;
}
